// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"e190bac9","728":"7ae85b8c"}[chunkId] + ".chunk.js";
};